:host {
  @apply flex flex-col items-start gap-2;
}

.input {
  --background: var(--highlight);
  --border-color: var(--stroke);
  --color: var(--on);
  --placeholder-color: var(--on-alt);
  --placeholder-opacity: 1;
  --highlight-color-focused: var(--accent);
  --highlight-color-invalid: var(--error);
  --highlight-color-valid: var(--success);
}

.label {
  @apply text-on;
}

.error-text {
  @apply text-error leading-3;
}

.helper-text {
  @apply text-on;
}

ion-input .native-input {
  height: 100%;
}
